import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { Box } from "../Box/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { Typography } from "../Typography/index.js";
import { useIsDesktop } from "../hooks/index.js";
import { ErrorFileImage } from "../graphics/index.js";
import { useStyles } from "./FilePreviewWrapper.styles.js";
const defaultSpasing = {};
const Error = (t0)=>{
    const $ = c(5);
    const { withoutError: t1 } = t0;
    const withoutError = void 0 === t1 ? false : t1;
    const isDesktop = useIsDesktop();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            mt: defaultSpasing,
            mb: defaultSpasing
        };
        $[0] = t2;
    } else t2 = $[0];
    const { classes } = useStyles(t2);
    let t3;
    if ($[1] !== classes || $[2] !== isDesktop || $[3] !== withoutError) {
        t3 = /*#__PURE__*/ jsx(Tooltip, {
            placement: "top",
            title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u0430\u0439\u043B\u0430",
            children: withoutError ? /*#__PURE__*/ jsx(Box, {
                height: "100%",
                width: "100%"
            }) : /*#__PURE__*/ jsxs(Box, {
                className: classnames("aqa_file_preview_error", classes.errorFile),
                children: [
                    /*#__PURE__*/ jsx(Box, {
                        mb: "4",
                        fontSize: 56,
                        height: 56,
                        children: /*#__PURE__*/ jsx(ErrorFileImage, {})
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        mb: {
                            xs: "0",
                            md: "8"
                        },
                        children: /*#__PURE__*/ jsx(Typography, {
                            display: "block",
                            variant: "caption",
                            color: isDesktop ? "text.light.tertirary" : "original.brand.primary",
                            align: "center",
                            children: "Ошибка при загрузке файла"
                        })
                    })
                ]
            })
        });
        $[1] = classes;
        $[2] = isDesktop;
        $[3] = withoutError;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
export { Error };
